import { render, staticRenderFns } from "./ParetoClients.vue?vue&type=template&id=369dbdf0"
import script from "./ParetoClients.vue?vue&type=script&lang=js"
export * from "./ParetoClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports